import {h, Component} from 'preact'
import {connect} from 'react-redux'
import reduce from '../reducers'
import * as actions from '../actions'
import constants from '../constants'
import {createPortal} from "preact/compat";

export default @connect(reduce, actions)
class IllustrationConfirmModal extends Component {
  constructor() {
    super();
  }

  render(props, state) {

    return props.open ? createPortal(<div>
      <div className="modal-back" onClick={props.onModalClose}></div>
      <div className="modal">
        <header>
          <h2>Confirm your upload</h2>
        </header>
        <div className="content">
          <p className={props.colors.length === 0 ? 'hidden' : ''}>
            We identified the following customizable colors in your illustration.
            <br/>
            Which ones should be editable? (Click the colors to choose)
            <br/><br/>
            <small style={"color: #ed5663"}>
              <strong>{props.objectCount}</strong> configurable objects found. This will add <strong>~{props.additionalSize.toFixed(2)}Mb</strong> to the final file size.
            </small>
          </p>

          <ul className="colors" style="padding: 1rem 0 2rem 0;">
            {props.colors.map(it => <li>
                <span
                  className={'color-box border ' + (it.isActive ? '' : 'inactive')}
                  style={'background:' + it.color}
                  onClick={() => props.toggleColor(it)}>
                    <svg className="icn"><use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-check"}/></svg>
                </span>
            </li>)}
          </ul>

          <div style="display: flex; width: 50px;">
            <input type="checkbox" id="toggleAllColorsCheckbox" onChange={props.toggleAllColors} />
            <label>All</label>
          </div>

          <footer>
            <a className="btn decline" onClick={props.onModalClose}>Abort</a>
            <a className="btn primary pull-right accept" onClick={props.onAccept}>Upload</a>
          </footer>
        </div>
      </div>
    </div>, document.getElementById('modals')) : null;
  }
}
